import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../../../api/queryKeys'
import { useAppContext } from '../../../../redux/slices/appContext'
import { postNamedQuery } from '../../../../service'

export const useListOrionClientDocuments = (queryParams, options = {}) => {
  const appContext = useAppContext()
  const { mapper, enabled = true, ...otherOptions } = options

  return useQuery({
    queryKey: [QUERY_KEYS.documentVault, 'orionClientDocuments', appContext.userId, appContext.firmId, queryParams],
    queryFn: async () => {
      const { data } = await postNamedQuery('vaultV2', 'list-orion-client-documents', queryParams)
      return data
    },
    select: data => mapper ? mapper(data) : data,
    enabled,
    ...otherOptions
  })
}
